type ListenerCallback<T> = (data: T) => void

class CustomEventHandler<T> {
    private listeners: ListenerCallback<T>[] = []

    public subscribe(callback: ListenerCallback<T>): void {
        this.listeners.push(callback)
    }

    public publish(data: T): void {
        this.listeners.forEach((listener: ListenerCallback<T>) => listener(data))
    }

    public unsubscribe(callback: ListenerCallback<T>): void {
        this.listeners = this.listeners.filter((listener: ListenerCallback<T>): boolean => listener !== callback)
    }
}

const customEventHandler: CustomEventHandler<number> = new CustomEventHandler<number>()

export default customEventHandler
